/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import { goodLuckCoreEntitiesAchievementRaritySchema } from "../entities/achievementRaritySchema.ts";
import { z } from "zod/v4";

export const goodLuckCoreDTOsAchievementDtoSchema = z.object({
  icon: z.string().nullish(),
  title: z.string().nullish(),
  description: z.string().nullish(),
  get rarity() {
    return goodLuckCoreEntitiesAchievementRaritySchema.optional();
  },
  category: z.string().nullish(),
  earnedAt: z.optional(z.iso.datetime()),
  progressCurrent: z.int().nullish(),
  progressMax: z.int().nullish(),
  progressCurrentTierOrder: z.int().nullish(),
  progressNextTierOrder: z.int().nullish(),
});
